module.exports = __webpack_public_path__ + "img/logo-sm.06c34a3a.png";